export const LABELS = {
  INTRO: 'Introduction',
  FIELD: 'Please tell us a bit about yourself',
  BUTTON_TEXT: 'Save and next',
  PLACEHOLDER: 'Let the agent know why you will make a great tenant',
  LATER: "I'LL DO IT LATER",
};

export const MAX_CHARACTERS_ALLOW = 1000;
